import { Outlet, useNavigation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Header from '../Header';
import DynamicBreadcrumbs from '../breadcrumbs/DynamicBreadcrumbs';
import pageStyles from '../pages/pageStyles';

const ManagementLayout = () => {
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';

  return (
    <Box>
      <Header />
      <Box sx={{ margin: 'auto', width: '80%' }}>
        <Box sx={pageStyles.dynamicBreadcrumbs}>
          <DynamicBreadcrumbs />
        </Box>
        {isLoading ? (
          <Stack
            alignItems="center"
            justifyContent="center"
            spacing={2}
            sx={{
              position: 'fixed',
              inset: 0,
            }}
          >
            <CircularProgress />
            <Typography variant="subtitle1" color="#1976d2">
              It may take up to a couple of seconds ...
            </Typography>
          </Stack>
        ) : (
          <Outlet />
        )}
      </Box>
    </Box>
  );
};

export default ManagementLayout;
